/*
*   This content is licensed according to the W3C Software License at
*   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
*/



/* ========================================================================== *\
	IMPORTS
\* ========================================================================== */

import isNil from 'lodash/isNil';
import PopupMenu from './popup-menu-links';

/* == IMPORTS =============================================================== */



/* ========================================================================== *\
	PRIVATE VARIABLES
\* ========================================================================== */

const
    moduleName = 'popup-menu-item-links',
    baseCssClass = `js-${moduleName}`,

    selectors = {
        base: `.${baseCssClass}`
    };

/* == PRIVATE VARIABLES ===================================================== */



/* ========================================================================== *\
	PRIVATE METHODS
\* ========================================================================== */

export default class PopupMenuItem {
    constructor(baseElement, menuObj) {
        const popupObj = typeof popupObj !== 'object' ? popupObj : false;

        this.baseElement = baseElement;
        this.menu = menuObj;
        this.popupMenu = false;
        this.isMenubarItem = false;

        this.keyCode = Object.freeze({
            'TAB': 9,
            'RETURN': 13,
            'ESC': 27,
            'SPACE': 32,
            'PAGEUP': 33,
            'PAGEDOWN': 34,
            'END': 35,
            'HOME': 36,
            'LEFT': 37,
            'UP': 38,
            'RIGHT': 39,
            'DOWN': 40
        });

        this.init();
    }

     isExpanded() {
        return this.baseElement.getAttribute('aria-expanded') === 'true';
    };

    /* EVENT HANDLERS */

    handleKeydown(event) {
        const tgt = event.currentTarget,
            char = event.key;

        let flag = false,
            clickEvent;

        function isPrintableCharacter(str) {
            return str.length === 1 && str.match(/\S/);
        }

        switch (event.keyCode) {
            case this.keyCode.SPACE:
            case this.keyCode.RETURN:
                if (this.popupMenu) {
                    this.popupMenu.Open();
                    this.popupMenu.setFocusToFirstItem();
                }
                else {

                    // Create simulated mouse event to mimic the behavior of ATs
                    // and let the event handler handleClick do the housekeeping.
                    try {
                        clickEvent = new MouseEvent('click', {
                            'view': window,
                            'bubbles': true,
                            'cancelable': true
                        });
                    }
                    catch (err) {
                        if (document.createEvent) {
                            // DOM Level 3 for IE 9+
                            clickEvent = document.createEvent('MouseEvents');
                            clickEvent.initEvent('click', true, true);
                        }
                    }
                    tgt.dispatchEvent(clickEvent);
                }

                flag = true;
                break;

            case this.keyCode.UP:
                this.menu.setFocusToPreviousItem(this);
                flag = true;
                break;

            case this.keyCode.DOWN:
                this.menu.setFocusToNextItem(this);
                flag = true;
                break;

            case this.keyCode.LEFT:
                this.menu.setFocusToController('previous', true);
                this.menu.Close(true);
                flag = true;
                break;

            case this.keyCode.RIGHT:
                if (this.popupMenu) {
                    this.popupMenu.Open();
                    this.popupMenu.setFocusToFirstItem();
                }
                else {
                    this.menu.setFocusToController('next', true);
                    this.menu.Close(true);
                }
                flag = true;
                break;

            case this.keyCode.HOME:
            case this.keyCode.PAGEUP:
                this.menu.setFocusToFirstItem();
                flag = true;
                break;

            case this.keyCode.END:
            case this.keyCode.PAGEDOWN:
                this.menu.setFocusToLastItem();
                flag = true;
                break;

            case this.keyCode.ESC:
                this.menu.setFocusToController();
                this.menu.Close(true);
                flag = true;
                break;

            case this.keyCode.TAB:
                this.menu.setFocusToController();
                break;

            default:
                if (isPrintableCharacter(char)) {
                    this.menu.setFocusByFirstCharacter(this, char);
                    flag = true;
                }
                break;
        }

        if (flag) {
            event.stopPropagation();
            event.preventDefault();
        }
    };

    setExpanded(value) {
        if (value) {
            this.baseElement.setAttribute('aria-expanded', 'true');
        }
        else {
            this.baseElement.setAttribute('aria-expanded', 'false');
        }
    };

    handleClick(event) {
        this.menu.setFocusToController();
        this.menu.Close(true);
    };

    handleFocus(event) {
        this.menu.hasFocus = true;
    };

    handleBlur(event) {
        this.menu.hasFocus = false;
        setTimeout(this.menu.Close.bind(this.menu, false), 300);
    };

    handleMouseover(event) {
        this.menu.hasHover = true;
        this.menu.Open();
        if (this.popupMenu) {
            this.popupMenu.hasHover = true;
            this.popupMenu.Open();
        }
    };

    handleMouseout(event) {
        if (this.popupMenu) {
            this.popupMenu.hasHover = false;
            this.popupMenu.Close(true);
        }

        this.menu.hasHover = false;
        setTimeout(this.menu.Close.bind(this.menu, false), 300);
    };

    init() {
        this.baseElement.tabIndex = -1;

        this.baseElement.addEventListener('keydown', this.handleKeydown.bind(this));
        this.baseElement.addEventListener('click', this.handleClick.bind(this));
        this.baseElement.addEventListener('focus', this.handleFocus.bind(this));
        this.baseElement.addEventListener('blur', this.handleBlur.bind(this));
        this.baseElement.addEventListener('mouseover', this.handleMouseover.bind(this));
        this.baseElement.addEventListener('mouseout', this.handleMouseout.bind(this));

        // Initialize flyout menu

        var nextElement = this.baseElement.nextElementSibling;

        if (nextElement && nextElement.tagName === 'UL') {
            this.popupMenu = new PopupMenu(nextElement, this);
            this.popupMenu.init();
        }
    }
}

function popupMenuLinks() {
   
    
}

/* == PRIVATE METHODS ======================================================= */



/* ========================================================================== *\
	INITIALIZATION
\* ========================================================================== */

function init(baseElement = document.querySelector(selectors.base)) {
    if (!isNil(baseElement)) {
        popupMenuLinks();
    }
}

init();

/* == INITIALIZATION ======================================================== */
